// Copyright (c) 2020 Deere & Company

export default Object.freeze({
    CLOSE_TABM_SPA_CLAIM_MODAL: 'CLOSE_TABM_SPA_CLAIM_MODAL',
    OPEN_TABM_SPA_CLAIM_MODAL: 'OPEN_TABM_SPA_CLAIM_MODAL',
    RESET_TABM_SPA_CLAIMS_SEARCH_FILTERS: 'RESET_TABM_SPA_CLAIMS_SEARCH_FILTERS',
    RESET_TABM_SPA_CLAIM_DETAILS: 'RESET_TABM_SPA_CLAIM_DETAILS',
    RESET_TABM_WIP_TABM_SETTINGS_FACET: 'RESET_TABM_WIP_TABM_SETTINGS_FACET',
    TOGGLE_TABM_REPORTS_ACCORDION: 'TOGGLE_TABM_REPORTS_ACCORDION',
    TOGGLE_TABM_WIP_SPA_LEVELS_LIST: 'TOGGLE_TABM_WIP_SPA_LEVELS_LIST',
    UPDATE_TABM_AUDIT_DEALER_HIERARCHY_FACET: 'UPDATE_TABM_AUDIT_DEALER_HIERARCHY_FACET',
    UPDATE_TABM_AUDIT_FACET_FILTER_TEXT: 'UPDATE_TABM_AUDIT_FACET_FILTER_TEXT',
    UPDATE_TABM_AUDIT_FILTERED_TERRITORIES: 'UPDATE_TABM_AUDIT_FILTERED_TERRITORIES',
    UPDATE_TABM_AUDIT_IS_INITIAL_LOAD: 'UPDATE_TABM_AUDIT_IS_INITIAL_LOAD',
    UPDATE_TABM_CLAIM_DEBIT_TYPE: 'UPDATE_TABM_CLAIM_DEBIT_TYPE',
    UPDATE_TABM_CLAIM_DEBIT_TYPES: 'UPDATE_TABM_CLAIM_DEBIT_TYPES',
    UPDATE_TABM_FACET_FILTER_TEXT: 'UPDATE_TABM_FACET_FILTER_TEXT',
    UPDATE_TABM_FILTERED_TERRITORIES: 'UPDATE_TABM_FILTERED_TERRITORIES',
    UPDATE_TABM_IS_INITIAL_LOAD: 'UPDATE_TABM_IS_INITIAL_LOAD',
    UPDATE_TABM_SEARCH_BY: 'UPDATE_TABM_SEARCH_BY',
    UPDATE_TABM_SEARCH_QUERY_STRING: 'UPDATE_TABM_SEARCH_QUERY_STRING',
    UPDATE_TABM_SPA_CLAIMS: 'UPDATE_TABM_SPA_CLAIMS',
    UPDATE_TABM_SPA_CLAIMS_FILTER_BY: 'UPDATE_TABM_SPA_CLAIMS_FILTER_BY',
    UPDATE_TABM_SPA_CLAIMS_QUERY: 'UPDATE_TABM_SPA_CLAIMS_QUERY',
    UPDATE_TABM_SPA_CLAIMS_SORT_BY: 'UPDATE_TABM_SPA_CLAIMS_SORT_BY',
    UPDATE_TABM_SPA_CLAIMS_SORT_DIRECTION: 'UPDATE_TABM_SPA_CLAIMS_SORT_DIRECTION',
    UPDATE_TABM_SPA_CLAIM_COMMENTS_TO_DEALER: 'UPDATE_TABM_SPA_CLAIM_COMMENTS_TO_DEALER',
    UPDATE_TABM_SPA_CLAIM_CONTRIBUTION: 'UPDATE_TABM_SPA_CLAIM_CONTRIBUTION',
    UPDATE_TABM_SPA_CLAIM_DETAILS: 'UPDATE_TABM_SPA_CLAIM_DETAILS',
    UPDATE_TABM_SPA_CLAIM_INTERNAL_DEERE_COMMENTS: 'UPDATE_TABM_SPA_CLAIM_INTERNAL_DEERE_COMMENTS',
    UPDATE_TABM_SPA_CLAIM_SELECTED_CONTRIBUTION: 'UPDATE_TABM_SPA_CLAIM_SELECTED_CONTRIBUTION',
    UPDATE_TABM_SPA_CLAIM_STATUS: 'UPDATE_TABM_SPA_CLAIM_STATUS',
    UPDATE_TABM_SPA_TYPE: 'UPDATE_TABM_SPA_TYPE',
    UPDATE_TABM_SPA_TYPES: 'UPDATE_TABM_SPA_TYPES',
    UPDATE_TABM_WIP_FACETS: 'UPDATE_TABM_WIP_FACETS',
    UPDATE_TABM_WIP_SELECTED_SPA_LEVELS: 'UPDATE_TABM_WIP_SELECTED_SPA_LEVELS',
    UPDATE_TABM_WIP_SELECTED_SPA_LEVELS_LIST: 'UPDATE_TABM_WIP_SELECTED_SPA_LEVELS_LIST',
    UPDATE_TABM_WIP_TABM_SETTINGS: 'UPDATE_TABM_WIP_TABM_SETTINGS',
    UPDATE_USER_TERRITORIES: 'UPDATE_USER_TERRITORIES'
});



// WEBPACK FOOTER //
// ./src/tabm/actions-list.js